import React from 'react'

function  DatosPersonales({datosPersonales}){
    return (
        <md-content className="col-sm-3 comboEditable _md" >
            <div>                        
                <p><label> USUARIO: &nbsp;</label>{datosPersonales.nif} - {datosPersonales.razonSocial}</p>                          
            </div>
        </md-content>)
}
export default DatosPersonales